var a={InputPage:"InputPage__InputPage-JYl"};export{a as default};
